// removed by extract-text-webpack-plugin
module.exports = {"text-field":"TextField__text-field","textField":"TextField__text-field"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextField/TextField.desktop.css
// module id = 1032
// module chunks = 8